const email = '/assets/ivergrama/General/email-icon.svg';
const PopupIcon = '/assets/ivergrama/gallery/gallery5.jpg';
const Booking = '/assets/aeroquinta/Home/compra-tu-pasaje.svg';
const BookingActive = '/assets/aeroquinta/Home/compra-tu-pasaje.svg';
const Cancel = '/assets/aeroquinta/Home/anular-pasaje.svg';
const CancelActive = '/assets/aeroquinta/Home/anular-pasaje.svg';
const ChangeActive = '/assets/ivergrama/Home/change-ticket.svg';
const CuponeraActive = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-Cuponera.svg';
const ConfirmCuponeraActive =
	'/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-Confirm-Cuponera.svg';

const OriginIcon = '/assets/aeroquinta/Home/Origen.svg';
const DestinationIcon = '/assets/aeroquinta/Home/Destino.svg';
const CalendarIcon = '/assets/aeroquinta/Home/Calender.svg';
// const SearchIcon = '/assets/ivergrama/Home/Ivergrama-Website-Home-SearchBar-SearchIcon.svg';
const titleUnderline = '/assets/aeroquinta/General/aeroquinta-website-titles.svg';

const sendBtn = '/assets/ivergrama/Home/Ivergrama-Website-Home-SendContact.svg';
const contactFormImg = '/assets/aeroquinta/Home/aeroquinta-Website-Home-BannerSpecialServices.webp';

const fb = '/assets/aeroquinta/General/icon_facebook.svg';
const instagram = '/assets/aeroquinta/General/icon_instagram.svg';
const instagramHover = '/assets/aeroquinta/General/icon_instagram_hover.svg';
const fbHover = '/assets/aeroquinta/General/icon_facebook_hover.svg';
const twitter = '/assets/ivergrama/General/Ivergrama-Website-Footer-SocialMedia-Twitter.svg';
const twitterHover =
	'/assets/ivergrama/General/Ivergrama-Website-Footer-SocialMedia-Twitter-Hover.svg';

const LocationIcon = '/assets/ivergrama/general/LocationIcon.svg';
const Phone = '/assets/aeroquinta/General/Teléfono.png';
const HeaderLogo = '/assets/ivergrama/general/Header-BusesTepualLogo.svg';
const FooterLogo = '/assets/ivergrama/general/Footer-BusesTepualLogo.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const BottomFooterKuposLogo = '/assets/common/Footer-kuposLogo.svg';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/aeroquinta/General/BusesAeroquinta-WhereToFindMyPNR.svg';

const contactMail = '/assets/aeroquinta/Contact/correo.png';
const contactAddress = '/assets/aeroquinta/Contact/contact.svg';

const servicesBanner = '/assets/aeroquinta/Home/Banner-nuestros-servicios.png';

const aboutUsImage = '/assets/aeroquinta/About-us/aeroquinta-Website-AboutUs-HistoryImage.webp';
// banners
const destinationBanner = '/assets/ivergrama/destinations/destination-main.jpg';
const serviceBanner = '/assets/ivergrama/Services/Ivergrama-Website-Services-MainBanner.jpg';
const faqBanner = '/assets/ivergrama/Home/Preguntas-frecuentes-banner.png';
const contactUsBanner = '/assets/aeroquinta/Contact/aeroquinta-Website-Contact-MainBanner.webp';
const aboutUsBanner = '/assets/aeroquinta/About-us/Aeroquinta-Website-AboutUs-MainBanner.webp';
const tncBanner = '/assets/aeroquinta/Tnc/Aeroquinta-Website-TermsAndConditions-MainBanner.webp';
const fleetBanner = '/assets/aeroquinta/Fleets/fleets-banner.webp';

const fleetsIcon1 = '/assets/aeroquinta/Fleets/fleetsIcon1.svg';
const fleetsIcon2 = '/assets/aeroquinta/Fleets/fleetsIcon2.svg';
const fleetsIcon3 = '/assets/aeroquinta/Fleets/fleetsIcon3.svg';
const fleetsIcon4 = '/assets/aeroquinta/Fleets/fleetsIcon4.svg';

const OfficePhoneIcon = '/assets/ivergrama/general/officePhone.svg';

const success = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-CheckMark-Blue.svg';
const failure = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-Information-Blue.svg';

const tick = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-Tick-Blue.svg';
const heartOn = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-HeartOn-Blue.svg';
const heartOff = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-HeartOff-Blue.svg';
const downArrow = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-DropDown-Blue.svg';
const registrationSuccess =
	'/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-RightDocument-Blue.svg';
const userIcon = '/assets/aeroquinta/Gray/aeroquinta-logo.png';

const trips = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-MyTrips-Blue.svg';
const cards = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-MyCards-Blue.svg';
const wallet = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const transaction = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-ShareMoney-Blue.svg';
const otp = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-RestorePassword-Blue.svg';

const paso_1 = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const paso_2 = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-RechargePoints-Blue.svg';
const paso_3 = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-ID-Blue.svg';
const paso_4 = '/assets/aeroquinta/Blue/MyAccount-IllustratedIcons-Tickets-Blue.svg';

//  pet seat
const petseatref =
	'/assets/ivergrama/pet/Ivergrama-ResultPage-SeatPick-PetsOnBoard_Pet Paw Icon (Amenite).svg';
const petseatModal = '/assets/ivergrama/pet/PopUp.png';
const petfilteroff = '/assets/ivergrama/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_off.svg';
const petfilteron = '/assets/ivergrama/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_On.svg';

const operatorPay = 'kupos-desktop/kupos-desktop-react/public/assets/santamaria/SMPaypng.png';
const whiteDownArrow = 'assets/ivergrama/Home/Down-arrow.svg';
const tncDownArrow = 'assets/aeroquinta/Tnc/arrow-icon.svg';
const accordOpen = 'assets/centropuerto/Preguntas/P.frecuentes-active.png';
const accordClose = 'assets/centropuerto/Preguntas/P.frecuentes-inactive.png';
const aeroquintaIcons = [

	{ icon: downArrow, name: 'downArrow' },
	{ icon: tncDownArrow, name: 'tncDownArrow' },

	{ icon: whiteDownArrow, name: 'whiteDownArrow' },
	{ icon: accordOpen, name: 'accordOpen' },
	{ icon: accordClose, name: 'accordClose' },

	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: Phone, name: 'phone' },
	{ icon: email, name: 'email' },
	{ icon: LocationIcon, name: 'location' },
	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },
	{ icon: contactFormImg, name: 'contactFormImg' },
	{ icon: titleUnderline, name: 'titleUnderline' },

	{ icon: sendBtn, name: 'sendBtn' },
	{ icon: fb, name: 'fb' },
	{ icon: instagram, name: 'instagram' },
	{ icon: instagramHover, name: 'instagramHover' },
	{ icon: fbHover, name: 'fbHover' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: twitter, name: 'twitter' },
	{ icon: twitterHover, name: 'twitterHover' },

	{ icon: Booking, name: 'BA' },
	{ icon: BookingActive, name: 'BIA' },
	{ icon: Cancel, name: 'CA' },
	{ icon: CancelActive, name: 'CIA' },
	{ icon: Cancel, name: 'CA' },
	{ icon: CancelActive, name: 'CIA' },
	{ icon: CuponeraActive, name: 'CUA' },
	{ icon: ChangeActive, name: 'CTA' },
	{ icon: ChangeActive, name: 'CTIA' },
	{ icon: ConfirmCuponeraActive, name: 'CUIA' },

	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: CalendarIcon, name: 'Calendar' },
	// { icon: SearchIcon, name: 'Search' },
	{ icon: PopupIcon, name: 'Popup' },
	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: BottomFooterKuposLogo, name: 'BottomFooterKuposLogo' },
	{ icon: animation, name: 'animation' },
	{ icon: pnr, name: 'pnr' },
	{ icon: OfficePhoneIcon, name: 'OfficePhoneIcon' },

	{ icon: contactMail, name: 'aeroquintaMail' },
	{ icon: contactAddress, name: 'aeroquintaContact' },
	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: faqBanner, name: 'faqBanner' },
	{ icon: serviceBanner, name: 'serviceBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsImage, name: 'aboutUsImage' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: fleetBanner, name: 'fleetBanner' },

	{ icon: fleetsIcon1, name: 'fleetsIcon1' },
	{ icon: fleetsIcon2, name: 'fleetsIcon2' },
	{ icon: fleetsIcon3, name: 'fleetsIcon3' },
	{ icon: fleetsIcon4, name: 'fleetsIcon4' },

	//  pet seat
	{ icon: petseatref, name: 'petseatref' },
	{ icon: petseatModal, name: 'petseatModal' },
	{ icon: petfilteron, name: 'petfilteron' },
	{ icon: petfilteroff, name: 'petfilteroff' },
	{ icon: operatorPay, name: 'operatorPay' },

	{ icon: servicesBanner, name: 'servicesBanner' },
];

export default aeroquintaIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/aeroquintaIcons.js